import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(36)}
    height={scaleSize(48)}
    viewBox="0 0 36 48"
    className="pause"
  >
    <g fill="#FFF" fillRule="evenodd">
      <rect width="12" height="48" rx="2" />
      <rect width="12" height="48" x="24" rx="2" />
    </g>
  </svg>
);
